import styled from "styled-components";
import { CommonRechargeCard } from "../../atom";

export const PictureNormalVipWrapper = styled.div`
  .rule-text {
    position: absolute;
    right: 0;
    top: -48px;
  }
`;

export const PictureNormalVipRechargeCard = styled(CommonRechargeCard)`
  .recharge-price {
    margin-top: 7px;
    height: 42px;
  }
  .recharge-vip {
    color: #ffffff;
    font-size: 14px;
  }
`;

export const RechargePerMonth = styled.div`
  font-size: 14px;
  color: #ffffff;
  line-height: 20px;
  margin-top: 15px;
`;
